import { ChangeDetectionStrategy, Component, Input, OnInit } from "@angular/core";
import { Zone } from "@common/ADAPT.Common.Model/methodology/zone";
import { Role } from "@common/ADAPT.Common.Model/organisation/role";
import { Team } from "@common/ADAPT.Common.Model/organisation/team";

enum GroupType {
    TeamGroup,
    RoleGroup,
    ZoneGroup,
    UnknownGroup,
}

@Component({
    selector: "adapt-link-system-group",
    templateUrl: "./link-system-group.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class LinkSystemGroupComponent implements OnInit {
    @Input() public groupKey?: Team | Role | Zone;

    public readonly GroupType = GroupType;
    public groupType = GroupType.UnknownGroup;

    public ngOnInit() {
        if (this.groupKey instanceof Team) {
            this.groupType = GroupType.TeamGroup;
        } else if (this.groupKey instanceof Role) {
            this.groupType = GroupType.RoleGroup;
        } else if (this.groupKey) {
            this.groupType = GroupType.ZoneGroup;
        }
    }
}
